import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "reactstrap";
import { FaExclamation, FaRegGrinBeamSweat } from "react-icons/fa";

import ConstData from "../../../lib/ConstData";
import { oAlertKind } from "../../../lib/ConstCommand";

import Alerts from "../list/Alerts";

const AlertModal = ({ isModalOpened, alertType, alertKind, alertMessage, handleSelectedFunc }) => {
    const { t } = useTranslation();

    const [lAlertKind, setAlertKind] = useState(ConstData.ALERT_KIND.NONE);
    const [lAlertMessage, setAlertMessage] = useState("");

    useEffect(() => {
        setAlertKind(alertKind);
    }, [alertKind])

    useEffect(() => {
        setAlertMessage(alertMessage);
    }, [alertMessage])

    const onCloseModal = () => {
        setAlertKind("");
        setAlertMessage("");
    }

    return (
        <Modal isOpen={isModalOpened} centered backdrop={true} onClosed={onCloseModal} className="hc-login-alert-modal" contentClassName="hc-login-alert-content">
            <div className="hc-login-alert-card">
                <div className="hc-login-alert-body">
                    {
                        alertType && alertType === oAlertKind.INVALID ?
                            <div className="hc-login-alert-title hc-login-alert-title-invalid">
                                <FaRegGrinBeamSweat className="hc-login-alert-icon" />
                            </div> :
                            <div className="hc-login-alert-title">
                                <FaExclamation className="hc-login-alert-icon" />
                                <span className="hc-login-alert-heading">{t("에러", { ns: "common" })}</span>
                            </div>
                    }
                    <div className="hc-login-alert-message">
                        <Alerts kind={lAlertKind} message={lAlertMessage} />
                    </div>
                    <button type="button" className="hc-login-alert-confirm" onClick={() => handleSelectedFunc({ selectedFunc: "TOGGLE_ALERT_MODAL" })}>{t("확인", { ns: "common" })}</button>
                </div>
            </div>
        </Modal>
    );
}

export default AlertModal;